import React from 'react';
import { Card, Form, Button } from 'react-bootstrap';
const uuid = require('uuid');
const find = require('lodash/find');
const has = require('lodash/has');

const RegistrationTokenStore = require('../../stores/registration_token_store');
const RegistrationTokenActions = require('../../actions/registration_token_actions');
import SortableTableClassic from '../table/SortableTableClassic';
import ErrorBox from '../common/ErrorBox';
import DefinitionListMapped from '../common/definition_list_mapped';

class AdminRegistrationTokenView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            registrationTokenStoreState: RegistrationTokenStore.getState(),
            selectedTokenId: null,
            newTokenName: "",
            newTokenDescription: "",
            addActionId: null,
        }

        this.onTokenClick = this.onTokenClick.bind(this);
        this.onNewTokenNameChange = this.onNewTokenNameChange.bind(this);
        this.onNewTokenDescriptionChange = this.onNewTokenDescriptionChange.bind(this);
        this.onTokenAdd = this.onTokenAdd.bind(this);
        this.unsubscribeRegTokenStore = RegistrationTokenStore.listen(this.onRegistrationTokenStoreChange.bind(this));
    }

    componentWillUnmount() {
        this.unsubscribeRegTokenStore();
    }

    onRegistrationTokenStoreChange(state) {
        let additionalState = {};
        if (this.state.addActionId == state.action.id) {
            additionalState = { ...additionalState, addActionId: null };
            if (!state.error) {
                additionalState = {
                    ...additionalState,
                    newTokenName: "",
                    newTokenDescription: "",
                };
            }
        }

        this.setState({
            registrationTokenStoreState: state,
            ...additionalState,
        });
    }

    onTokenClick(e, tokenId) {
        this.setState({ selectedTokenId: tokenId });
    }

    onNewTokenNameChange(e) {
        this.setState({ newTokenName: e.target.value })
    }

    onNewTokenDescriptionChange(e) {
        this.setState({ newTokenDescription: e.target.value })
    }

    onTokenAdd(e) {
        const actionId = uuid.v4();
        this.setState({ addActionId: actionId }, () => {
            RegistrationTokenActions.addToken(actionId, {
                token: this.state.newTokenName,
                description: this.state.newTokenDescription
            });
        })
    }

    render() {
        if (!this.state.registrationTokenStoreState) {
            return null;
        }

        return (
            <div>
                <ErrorBox error={this.state.registrationTokenStoreState.action.error}/>
                <div className="margin-bottom-lg">
                    <Card body bg="light">
                        <h2 className="view-title">
                            Add Registration Token
                        </h2>
                        <Form>
                            <Form.Group controlId="token-name">
                            {/*validationState={this.getValidationState('token')}>*/}
                                <Form.Label>token name:</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={this.state.newTokenName}
                                    onChange={this.onNewTokenNameChange}
                                />
                            </Form.Group>
                            <Form.Group controlId="token-desc">
                            {/*validationState={this.getValidationState('description')}>*/}
                                <Form.Label>description:</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={this.state.newTokenDescription}
                                    onChange={this.onNewTokenDescriptionChange}
                                />
                            </Form.Group>
                            <Button onClick={this.onTokenAdd} disabled={!!this.addActionId}>
                                add
                            </Button>
                        </Form>
                    </Card>
                </div>

                <Card body bg="light">
                    <SortableTableClassic
                        key="t-tokens"
                        title="Registration Tokens"
                        onRowClick={this.onTokenClick}
                        rows={this.state.registrationTokenStoreState.tokens}
                        selectedRowKey={this.state.selectedTokenId}
                        columns={[
                            {
                                displayName: 'ID',
                                key:'id',
                                size: 1,
                                type: 'int'
                            },
                            {
                                displayName: 'Token',
                                key:'token',
                                size: 1,
                                type: 'string'
                            },
                            {
                                displayName: 'Description',
                                key:'description',
                                size: 2,
                                type: 'string'
                            },
                            {
                                displayName: 'Create Date',
                                key:'create_date',
                                size: 2,
                                type: 'date'
                            }
                        ]}
                    />
                </Card>

                {(!!this.state.selectedTokenId) &&
                    <div className="margin-top-lg">
                        <Card body bg="light">
                            <DefinitionListMapped
                                className="inline-list-elems list-spaced"
                                definitions={find(this.state.registrationTokenStoreState.tokens, { id: this.state.selectedTokenId}) }
                            />
                        </Card>
                    </div>
                }
            </div>
        )
    }
}

AdminRegistrationTokenView.propTypes = {}

export default AdminRegistrationTokenView;